/** New line */
export const __NL__ = `\n`
